<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
        <form [formGroup]="doctoCForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100" class="pr-1"><br></div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Transportador</mat-label>
                <input [matAutocomplete]="autoTransp" matInput type="text" name="cadCadastroTransp"
                  formControlName="cadCadastroTransp" placeholder="Transportador"
                  (focus)="onFocusTransp($event);$event.target.select()" value="">
              </mat-form-field>
              <small
                *ngIf="doctoCForm.controls['cadCadastroTransp'].hasError('required') && doctoCForm.controls['cadCadastroTransp'].touched"
                class="form-error-msg"> Destinatário é obrigatório </small>
              <mat-autocomplete #autoTransp="matAutocomplete" [displayWith]="displayFnCadastro"
                (optionSelected)="onSelectionChangeTransp($event)">
                <mat-option *ngIf="isLoadingTransp" class="is-loading">
                  <mat-spinner diameter="30"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoadingTransp">
                  <mat-option *ngFor="let d of transps" [value]="d">
                    <span>{{ d.codigo?.toString()?.padStart(6, '0') +"-" + d.razaoSocial}}</span>
                    <!-- <span> {{b.descricao.trim()}}</span> -->
                  </mat-option>
                </ng-container>
                <mat-option>
                  <button mat-icon-button (click)="addTransp()">
                    <mat-icon color="primary">add</mat-icon> Transportador
                  </button>
                </mat-option>
              </mat-autocomplete>
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>CNPJ/CPF Transp.</mat-label>
                <input [imask]="maskUpper" matInput name="transpCnpjCpf" matInput type="text"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['transpCnpjCpf']"
                  placeholder="cnpj/cpf Transp.">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpCnpjCpf'].hasError('required') && doctoCForm.controls['transpCnpjCpf'].touched"
                      class="form-error-msg"> cnpj/cpf do transportador é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Nome Transp.</mat-label>
                <input [imask]="maskUpper" matInput name="transpNome" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['transpNome']" placeholder="Nome Transp.">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Cidade Transp.</mat-label>
                <input [imask]="maskUpper" matInput name="transpCidade" matInput type="text"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['transpCidade']"
                  placeholder="Cidade Transp.">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>UF Transp.</mat-label>
                <mat-select [formControl]="doctoCForm.controls['transpUf']" placeholder="UF Transp.">
                  <mat-option *ngFor="let estado of estados" [value]="estado.uf">
                    {{estado.uf}} - {{estado.estado}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Endereço Transp.</mat-label>
                <input [imask]="maskUpper" matInput name="transpEndereco" matInput type="text"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['transpEndereco']"
                  placeholder="Endereço Transp.">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>IE/RG Transp.</mat-label>
                <input [imask]="maskUpper" matInput name="transpIeRg" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['transpIeRg']" placeholder="IE/RG Transp.">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Modalidade do Frete</mat-label>
                <mat-select [formControl]="doctoCForm.controls['frete']" required placeholder="Modalidade do Frete">
                  <mat-option *ngFor="let frete of modalidadesFrete" [value]="frete.codigo">
                    {{frete.codigo}} - {{frete.descricao}}
                  </mat-option>
                </mat-select>
  
              </mat-form-field>
  
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
            <div fxFlex="100" class="pr-1">
              <mat-divider></mat-divider>
            </div>
  
  
            <div fxFlex="30" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Motorista</mat-label>
                <input [matAutocomplete]="autoMotor" matInput type="text" name="cadCadastroMotorista"
                  formControlName="cadCadastroMotorista" placeholder="Motorista"
                  (focus)="onFocusMotorista($event);$event.target.select()" value="">
              </mat-form-field>
              <mat-autocomplete #autoMotor="matAutocomplete" [displayWith]="displayFnCadastro"
                (optionSelected)="onSelectionChangeMotorista($event)">
                <mat-option *ngIf="isLoadingMotorista" class="is-loading">
                  <mat-spinner diameter="30"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoadingMotorista">
                  <mat-option *ngFor="let d of motoristas" [value]="d">
                    <span>{{ d.codigo?.toString()?.padStart(6, '0') +"-" + d.razaoSocial}}</span>
                    <!-- <span> {{b.descricao.trim()}}</span> -->
                  </mat-option>
                </ng-container>
                <mat-option>
                  <button mat-icon-button (click)="addMotorista()">
                    <mat-icon color="primary">add</mat-icon> adicionar Motorista
                  </button>
                </mat-option>
              </mat-autocomplete>
            </div>
  
            <div fxFlex="25" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Descrição do Veículo</mat-label>
                <input [imask]="maskUpper" matInput name="transpDescricaoVeiculo" matInput type="text"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['transpDescricaoVeiculo']"
                  placeholder="Descricao veiculo">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpCnpjCpf'].hasError('required') && doctoCForm.controls['transpCnpjCpf'].touched"
                      class="form-error-msg"> cnpj/cpf do transportador é obrigatório </small> -->
            </div>
  
            <div fxFlex="15" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>UF do Veículo</mat-label>
                <mat-select [formControl]="doctoCForm.controls['transpUfVeiculo']" placeholder="UF do Veículo">
                  <mat-option *ngFor="let estado of estados" [value]="estado.uf">
                    {{estado.uf}} - {{estado.estado}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
            <div fxFlex="15" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Placa do Veículo</mat-label>
                <input [imask]="maskUpper" matInput name="transpPlacaVeiculo" matInput type="text"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['transpPlacaVeiculo']"
                  placeholder="Placa veículo">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="15" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>RNTRC</mat-label>
                <input [imask]="maskUpper" matInput name="transpRntrc" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['transpRntrc']" placeholder="RNTRC">
              </mat-form-field>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
            <div fxFlex="100" class="pr-1">
              <mat-divider></mat-divider>
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field>
                <mat-label>Volumes</mat-label>
                <input matInput name="volumes" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['volumes']" placeholder="Volumes" (change)="fixaVolumes()" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
              </mat-form-field>
  
              <mat-checkbox fixaVolumes="app" [formControl]="doctoCForm.controls['fixaVolumes']">Fixar ?</mat-checkbox>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field>
                <mat-label>Peso Bruto</mat-label>
                <input matInput name="pesobruto" matInput type="text" step="any" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['pesobruto']" placeholder="Peso Bruto" (change)="fixaPesoBruto()" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
              </mat-form-field>
  
              <mat-checkbox name="app" [formControl]="doctoCForm.controls['fixaPesoBruto']">Fixar ?</mat-checkbox>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched" class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
            <div fxFlex="50" class="pr-1">
              <mat-form-field>
                <mat-label>Peso Líquido</mat-label>
                <input matInput name="pesoliquido" matInput type="text" step="any" (change)="fixaPesoLiquido()"
                  (focus)="$event.target.select()" [formControl]="doctoCForm.controls['pesoliquido']"
                  placeholder="Peso Líquido" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
              </mat-form-field>
  
              <mat-checkbox name="app" [formControl]="doctoCForm.controls['fixaPesoLiquido']">Fixar ?</mat-checkbox>
              <!-- <small *ngIf="doctoCForm.controls['transpNome'].hasError('required') && doctoCForm.controls['transpNome'].touched"
                      class="form-error-msg"> Nome é obrigatório </small> -->
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Espécie</mat-label>
                <input [imask]="maskUpper" matInput name="especie" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['especie']" placeholder="Espécie">
              </mat-form-field>
  
            </div>
  
            <div fxFlex="50" class="pr-1">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Marca</mat-label>
                <input [imask]="maskUpper" matInput name="marca" matInput type="text" (focus)="$event.target.select()"
                  [formControl]="doctoCForm.controls['marca']" placeholder="Marca">
              </mat-form-field>
            </div>

            <!-- verify if serieCodigo from lcto is 57 show produtoPredominante -->
            <!-- <div fxFlex="50" class="pr-1" *ngIf="this.lcto.serie.serieModelo==='57'">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Produto Predominante</mat-label>
                <mat-select [formControl]="doctoCForm?.controls['produtoPred']!"  (selectionChange)="onSelectionChangeProduto($event)">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="doctoCForm?.controls['produtoSearch']!" placeholderLabel="Pesquisar Produto..."
                    noEntriesFoundLabel="Produto não encontrado" [searching]="searching">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let p of (this.produtos$ | async)" [value]="p">
                    <span>{{ p.codigo?.toString()?.padStart(6, '0') +"-" + p.descricao }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
             </div>  -->

             <!-- cteTotalCarga -->
             <div fxFlex="50" class="pr-1" *ngIf="this.lcto.serie.serieModelo==='57'">
               <mat-form-field>
                 <mat-label>Valor Total da Carga</mat-label>
                 <input [imask]="maskUpper" matInput name="cteTotalCarga" matInput type="text"
                   (focus)="$event.target.select()" [formControl]="doctoCForm.controls['cteTotalCarga']"
                   placeholder="Valor Total da Carga" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
                 </div>


  
          </div>
        </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
      (click)="this.save();$event.preventDefault();">{{"SAVE" |
      translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">{{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>